import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Switch } from '@chakra-ui/react';
import { clientStore } from 'apps/client/app';

export const ChangeRoleAction = observer((props: any) => {
  /* Widget which allows intermediators to switch between requesting as their own user or the intermediator role. */
  let switcher = null;

  const shouldOpenIntermediatorMode =
    clientStore.currentPortal === 'INTERMEDIATOR';

  if (clientStore.hasRole('INTERMEDIATOR')) {
    const text = shouldOpenIntermediatorMode
      ? 'Intermediator Mode'
      : `Viewing as ${clientStore?.tokenData?.jwtData?.user_name}`;

    useEffect(() => {
      // intermediator default open intermediator-mode
      if (!shouldOpenIntermediatorMode) {
        clientStore.ToggleCurrentPortal();
      }
    }, []);

    switcher = (
      <div className='flex items-center'>
        <span className='text-black text-sm mr-1' {...props}>
          {text}
        </span>
        <Switch
          mt={1}
          id='email-alerts'
          data-testid={
            shouldOpenIntermediatorMode
              ? 'IntermediatorPage-CoseIntermediatorMode'
              : 'IntermediatorPage-OpenIntermediatorMode'
          }
          isChecked={shouldOpenIntermediatorMode}
          onChange={() => {
            clientStore.ToggleCurrentPortal();
          }}
        />
      </div>
    );
  }

  return switcher;
});
